module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-container",
    attrs: {
      "id": "login"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl()
    }
  })]), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'email') ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "instructions"
  }, [_vm._v("\n        Para recuperar su contraseña escriba el correo electronico con el que se registro.\n        Si coincide se le enviara un codigo para verificar su cuenta\n      ")]), _vm._v(" "), _c('md-field', [_c('md-input', {
    attrs: {
      "placeholder": _vm.emailHint,
      "autofocus": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.requestCode
    }
  }, [_vm._v("Solicitar Codigo")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'code') ? _c('div', {
    staticClass: "form"
  }, [_c('p', {
    staticClass: "instructions"
  }, [_vm._v("\n        Ingrese el código de verificación\n      ")]), _vm._v(" "), _c('code-input', {
    on: {
      "input": _vm.onCodeInput
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.verifyCode
    }
  }, [_vm._v("Validar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'password') ? _c('div', {
    staticClass: "form"
  }, [_c('md-field', [_c('label', [_vm._v("Ingrese su nueva contraseña")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('md-field', [_c('label', [_vm._v("Confirme su nueva contraseña")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Actualizar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'start') ? _c('div', {
    staticClass: "recovery-done"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v("Inicio de sesión")])], 1) : _vm._e(), _vm._v(" "), (_vm.steps[_vm.currentStep] === 'error') ? _c('div', {
    staticClass: "recovery-done"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v("Regresar al inicio")])], 1) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.modalInfo
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afb55d82","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordRecovery/PasswordRecovery.vue
// module id = 1714
// module chunks = 6